import { render, staticRenderFns } from "./DsioDetail.vue?vue&type=template&id=29aa0c27&"
import script from "./DsioDetail.vue?vue&type=script&lang=js&"
export * from "./DsioDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29aa0c27')) {
      api.createRecord('29aa0c27', component.options)
    } else {
      api.reload('29aa0c27', component.options)
    }
    module.hot.accept("./DsioDetail.vue?vue&type=template&id=29aa0c27&", function () {
      api.rerender('29aa0c27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioDetail.vue"
export default component.exports